import React from "react";

const Icon = (props) => {
  switch (props.name) {
    case "close":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 12 12"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
        >
          <path
            d="M.824 0L6 5.176 11.176 0 12 .941 6.824 6 12 11.176l-.824.824L6 6.824.824 12 0 11.176 5.176 6 0 .941z"
            fillRule="nonzero"
          />
        </svg>
      );
    case "arrowRight":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 8 12"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
        >
          <path
            d="M2.174 10L6 6.089 2 2"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
          />
        </svg>
      );
    case "arrowRightLarge":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 13 22"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
        >
          <path d="M2.355 21.78a.77.77 0 01-.512.22.768.768 0 01-.511-.22l-1.11-1.103A.712.712 0 010 20.171c0-.177.088-.375.222-.507L8.95 11 .222 2.337A.753.753 0 010 1.83c0-.176.088-.375.222-.507L1.332.22A.772.772 0 011.843 0c.178 0 .377.089.512.22l10.349 10.274c.133.131.222.33.222.506a.753.753 0 01-.222.507L2.354 21.78z" />
        </svg>
      );

    case "chevronLeft":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 24 44"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
        >
          <path d="M23.406 1.976L21.976.578.593 22.436l20.514 20.97 1.43-1.398-19.146-19.57z" />
        </svg>
      );

      case "externalLink":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 576 512"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
        >
          <path
            d="M448 279v185c0 27-21 48-48 48H48c-27 0-48-21-48-48V112c0-27 21-48 48-48h248a24 24 0 0117 7l16 16c15 15 4 41-17 41H64v320h320V295c0-6 3-12 7-17l16-16c15-15 41-4 41 17zM576 37c0-20-17-37-37-37H380c-15 0-28 13-28 28v18c0 16 13 28 29 28l67-2-249 247c-9 9-9 25 0 34l24 24c9 9 25 9 34 0l247-249-2 67c0 16 12 29 28 29h18c15 0 28-13 28-28V37z"
          />
        </svg>
      );

      case "lock":
        return (
          <svg
            className={props.className}
            style={props.style}
            aria-hidden="true"
            focusable="false"
            role="presentation"
            viewBox="0 0 12 16"
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
          >
            <path d="M5.25 11.359v1.368c0 .402.336.728.75.728s.75-.326.75-.728V11.36c.23-.2.375-.49.375-.814 0-.602-.504-1.09-1.125-1.09s-1.125.488-1.125 1.09c0 .324.145.614.375.814zM1.5 6.545V4.364C1.5 1.954 3.515 0 6 0s4.5 1.954 4.5 4.364v2.181h.75c.414 0 .75.326.75.728v8a.739.739 0 01-.75.727H.75a.739.739 0 01-.75-.727v-8c0-.402.336-.728.75-.728h.75zM6 1.455c-1.657 0-3 1.302-3 2.909v2.181h6V4.364c0-1.607-1.343-2.91-3-2.91z" fillRule="nonzero"/>
          </svg>
        );

    case "search":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
        >
          <path
            d="M.245 15.562l3.504-3.505a.843.843 0 01.598-.246h.573a7.276 7.276 0 01-1.547-4.5A7.31 7.31 0 0110.685 0a7.31 7.31 0 017.312 7.312 7.31 7.31 0 01-7.312 7.312 7.276 7.276 0 01-4.5-1.547v.573c0 .225-.087.44-.245.597l-3.505 3.505a.84.84 0 01-1.192 0l-.995-.995a.848.848 0 01-.003-1.195zm10.44-3.75c2.485 0 4.5-2.011 4.5-4.5 0-2.486-2.011-4.5-4.5-4.5-2.485 0-4.5 2.011-4.5 4.5 0 2.485 2.011 4.5 4.5 4.5z"
            fillRule="nonzero"
          />
        </svg>
      );
    case "plus":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
        >
          <path d="M9 0h2v20H9z" />
          <path d="M0 11V9h20v2z" />
        </svg>
      );
    case "minus":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          width={props.width}
          height={props.height}
        >
          <path d="M0 11V9h20v2z" />
        </svg>
      );
    case "minusCircle":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          width={props.width}
          height={props.height}
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle className="circle" strokeWidth="4" cx="50" cy="50" r="48" />
          <path className="symbol" d="M67 53v-7H37v7z" />
        </svg>
      );
    case "plusCircle":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          width={props.width}
          height={props.height}
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle className="circle" strokeWidth="4" cx="50" cy="50" r="48" />
          <path
            className="symbol"
            d="M54.46 71V53.57H69v-7.14H54.46V29h-6.92v17.43H33v7.14h14.54V71z"
          />
        </svg>
      );

    case "check":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          width={props.width}
          height={props.height}
          viewBox="0 0 12 9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7.3c-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3L4.2 6.6 1.7 4c-.4-.4-1-.4-1.4 0-.2.2-.3.4-.3.7 0 .3.1.5.3.7l3.2 3.3c.2.2.4.3.7.3.3 0 .5-.1.7-.3l6.8-7c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7z"
            fillRule="nonzero"
          />
        </svg>
      );
    case "circleCheck":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          width={props.width}
          height={props.height}
          viewBox="0 0 44 44"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 0c12.132 0 22 9.87 22 22 0 12.132-9.868 22-22 22C9.87 44 0 34.132 0 22 0 9.87 9.87 0 22 0zm0 3.242c-10.343 0-18.758 8.415-18.758 18.759 0 10.342 8.415 18.757 18.759 18.757 10.342 0 18.757-8.415 18.757-18.757 0-10.344-8.415-18.759-18.757-18.759zm8.334 10.68a1.624 1.624 0 012.284-.202c.686.577.776 1.598.201 2.285L21.022 30.08c-.3.358-.74.57-1.208.58h-.034a1.62 1.62 0 01-1.197-.53l-7.356-8.061a1.62 1.62 0 01.104-2.29 1.618 1.618 0 012.291.105l6.107 6.692z"
            fill-rule="nonzero"
          />
        </svg>
      );
    case "circleExclamation":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          width={props.width}
          height={props.height}
          viewBox="0 0 44 44"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fill="#c1481f" fillRule="nonzero">
              <path
                d="M22,44 C9.862,44 0,34.16 0,21.953 C0,9.746 9.862,0 22,0 C34.137,0 44,9.84 44,21.953 C44.094,34.159 34.232,44 22,44 Z M22,3.785 C11.948,3.785 3.793,11.923 3.793,21.953 C3.793,31.983 11.948,40.12 22,40.12 C32.051,40.12 40.206,31.983 40.206,21.953 C40.301,11.923 32.146,3.785 22,3.785 Z M23.896,11.355 L20.103,11.355 L20.103,25.359 L23.896,25.359 L23.896,11.355 Z M23.896,28.765 L20.103,28.765 L20.103,32.645 L23.896,32.645 L23.896,28.765 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </svg>
      );
    case "upLeftArrow":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          width={props.width}
          height={props.height}
          viewBox="0 0 9 8"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.5 7.5l-7-7m0-.5v7.5M1 .5h7.5"
            stroke="#000"
            fill="none"
            fillRule="evenodd"
            strokeLinejoin="bevel"
          />
        </svg>
      );
    case "closeCircle":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          width={props.width}
          height={props.height}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 27 27"
        >
          <circle
            cx="13.5"
            cy="13.5"
            r="12.5"
            fill="none"
            stroke="#c1481f"
            strokeWidth="2"
          />
          <path
            fillRule="evenodd"
            fill="#c1481f"
            d="M526.9 346.818l1.414-1.414 7.778 7.778-1.414 1.414z"
            transform="translate(-518 -336)"
          />
          <path
            fillRule="evenodd"
            fill="#c1481f"
            d="M534.617 345l1.383 1.383-7.617 7.617-1.383-1.383z"
            transform="translate(-518 -336)"
          />
        </svg>
      );
    case "infoCircle":
      return (
        <svg
          className={props.className}
          style={props.style}
          aria-hidden="true"
          focusable="false"
          role="presentation"
          width={props.width}
          height={props.height}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fillRule="evenodd" clipRule="evenodd" d="M16 4.5C9.64873 4.5 4.5 9.64873 4.5 16C4.5 22.3513 9.64873 27.5 16 27.5C22.3513 27.5 27.5 22.3513 27.5 16C27.5 9.64873 22.3513 4.5 16 4.5ZM3.5 16C3.5 9.09644 9.09644 3.5 16 3.5C22.9036 3.5 28.5 9.09644 28.5 16C28.5 22.9036 22.9036 28.5 16 28.5C9.09644 28.5 3.5 22.9036 3.5 16ZM14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.3978 14.5 15.7794 14.658 16.0607 14.9393C16.342 15.2206 16.5 15.6022 16.5 16V21C16.5 21.1326 16.5527 21.2598 16.6464 21.3536C16.7402 21.4473 16.8674 21.5 17 21.5C17.2761 21.5 17.5 21.7239 17.5 22C17.5 22.2761 17.2761 22.5 17 22.5C16.6022 22.5 16.2206 22.342 15.9393 22.0607C15.658 21.7794 15.5 21.3978 15.5 21V16C15.5 15.8674 15.4473 15.7402 15.3536 15.6464C15.2598 15.5527 15.1326 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15ZM17 10.5C17 11.3284 16.3284 12 15.5 12C14.6716 12 14 11.3284 14 10.5C14 9.67157 14.6716 9 15.5 9C16.3284 9 17 9.67157 17 10.5Z"/>
        </svg>
      );
    default:
      return null;
  }
};

export default Icon;